import { useTranslation } from 'react-i18next'

import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'

interface DeleteSocialLinkConfirmationPopupProps {
  onClose: VoidFunction
  onConfirm: () => Promise<void>
  serviceName: string
}

export const DeleteSocialLinkConfirmationPopup = ({
  onClose,
  onConfirm,
  serviceName,
}: DeleteSocialLinkConfirmationPopupProps) => {
  const { t } = useTranslation(['communication'])

  return (
    <ConfirmationPopup
      confirmText={t('communication:socialLinks.deleteConfirmation.confirm')}
      title={t('communication:socialLinks.deleteConfirmation.title')}
      variant="danger"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Typography>
        {t('communication:socialLinks.deleteConfirmation.body', { serviceName })}
      </Typography>
    </ConfirmationPopup>
  )
}
